/**
 * Keeps the footer above the on-screen keyboard.
 *
 * `interactive-widget=resizes-content` in the viewport meta does this on its
 * own wherever it is supported: the layout viewport shrinks, `dvh` shrinks with
 * it, and the sticky footer lands above the keyboard. iOS Safari ignores the
 * hint, so this measures what the keyboard still covers and publishes it as
 * `--kb` for the footer to sit on.
 *
 * The measurement is the residual overlap, not the keyboard height, which is
 * what makes it safe on both: where the layout viewport already shrank there is
 * nothing left over and `--kb` stays 0, so the footer is never lifted twice.
 */

const ROOT = document.documentElement;

export function startKeyboardInset(): void {
	const viewport = window.visualViewport;
	if (!viewport) return;

	const update = (): void => {
		const covered = window.innerHeight - (viewport.height + viewport.offsetTop);
		const inset = Math.max(0, Math.round(covered));
		ROOT.style.setProperty("--kb", `${inset}px`);
	};

	viewport.addEventListener("resize", update);
	viewport.addEventListener("scroll", update);
	update();
}
